<template>
  <div>
    <b-badge
      pill
      :variant="behaviorVariant"
      class="badge-width"
      v-b-tooltip.hover
      :title="formattedBehaviors"
    >
      {{ truncatedBehaviors }}
    </b-badge>
  </div>
</template>

<script>
import securityBehavior from '@/xvisor/constants/securityBehavior';

export default {
  props: {
    behavior: {
      type: Array, // Changed to Array
      required: true,
    },
  },
  data() {
    return {
      maxTextLength: 7,
    };
  },
  methods: {
    truncate(text, showEllipses = true) {
      if (text.length > this.maxTextLength) {
        const substring = text.substring(0, this.maxTextLength);
        return `${substring}${showEllipses ? '...' : ''}`;
      }
      return text;
    },
  },
  computed: {
    formattedBehaviors() {
      return this.behavior.length ? this.behavior.join(', ') : '';
    },
    truncatedBehaviors() {
      if (this.behavior.length > 1) {
        return `${this.truncate(this.behavior[0], false)}...`;
      }
      return this.truncate(this.behavior[0]);
    },
    // Determine the badge variant based on the behavior.
    behaviorVariant() {
      if (this.behavior.length && !this.behavior.includes(securityBehavior.normal.name)) {
        return 'warning';
      }
      return 'success';
    },
  },
};
</script>

<style scoped>
.badge-width {
  min-width: 85px;
  width: 50%;
}
</style>
